import React from 'react';
import {SignupStatusEnum} from "@/lib/helper/enumType";

function SignupStatusEnumComponent({text}) {

    if (text === null || typeof text === 'undefined') {
        return <span></span>
    }

    return (
        <span className={`rounded-lg px-2 py-1 text-xs ${SignupStatusEnum(text, 'color')}`}>
            {SignupStatusEnum(text)}
        </span>
    );
}

export default SignupStatusEnumComponent;